/**
 * Device ID utility
 * Generates and stores a unique device ID for the current browser/device
 */

const DEVICE_ID_KEY = 'focusmode_device_id';

/**
 * Get or generate a device ID
 * The device ID is stored in localStorage and persists across sessions
 */
export const getDeviceId = (): string => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  
  if (!deviceId) {
    // Generate a simple device ID (you can use a UUID library if needed)
    deviceId = `device_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  
  return deviceId;
};

